import axios from '../../config/axiosConfig';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { loadControlsFailure, loadControlsSuccess } from './controls.actions';

import { ControlActionTypes, ControlDict } from './models';

// TODO: Type db response object
/**
 * Fetches Controls from db, then dispatches an action with the corresponding result
 */
export function* loadControlsAsyncSaga(): Generator {
  try {
    const response = yield axios.get<ControlDict>('api/controls/getall')
      .then((res) => res.data);
    yield put(loadControlsSuccess(<ControlDict>response));
  } catch (error) {
    yield put(loadControlsFailure(error));
  }
}

/**
 * Listens for LOAD_CONTROLS_START action, dispatchs loadControlsAsyncSaga
 */
export function* loadControlsStartSaga(): Generator {
  yield takeLatest(ControlActionTypes.LOAD_CONTROLS_START, loadControlsAsyncSaga);
}

/**
 * Composite of all control sagas that are listening for external actions
 */
export function* controlsSagas(): Generator {
  yield all([call(loadControlsStartSaga)]);
}

export default controlsSagas;